import Layout from "./components/Layout";
import { ContextProvider } from "./contexts/AppContext";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MarkdownPage from "./components/MarkdownPage";
import Homepage from "./components/Homepage";

const App: React.FC = () => {

    return <ContextProvider>
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/posts/:post" element={<MarkdownPage />} />
                    <Route path="/" element={<Homepage />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    </ContextProvider>
}

export default App;
